<!-- 20-05-2024 survey -->


<template>
    <div class="position-relative">
        <loading v-if="loading !== 0 && is_popup == false"></loading>
        <section v-if="show_header" class="py-2 py-md-3 text-bat">
            <div class="container py-2">
                <div class="container">
                    <div class="breadcrumbs-retos">
                        <a href="/home-bat">
                            <img src="/img/icons/homeBread.svg" alt="" />
                        </a>
                        <a class="link cursor-pointer" href="#" @click="returnView()">A la practica </a>
                        <a class="link cursor-pointer" href="#" @click="returnView()">Encuesta /</a>
                        <span class="color-active-miga " v-if="survey !== null"><strong>{{ survey.name
                                }}</strong></span>
                    </div>
                    <a href="#" @click="returnView()"><img src="/img/icons/regresar.svg" alt="icon"></a>
                </div>
            </div>
        </section>

        <div v-if="this.questions.length > 0" class="container pb-5 datos text-bat">
            <div v-if="is_popup && survey && survey.video">
                <div class="embed-responsive embed-responsive-16by9" style="width:100%;">
                    <iframe class="embed-responsive-item my-2 w-100 rounded-1"
                        :src="survey.video + '&color=410978&autoplay=1&title=0&byline=0&portrait=0&autopause=0&muted=1&controls=1'"
                        style="width:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture"
                        allowfullscreen>
                    </iframe>
                </div>
            </div>
            <div v-else-if="is_popup && survey && survey.image">
                <img :src="survey.image" :alt="survey.name" class="my-2 w-100 rounded-1">
            </div>

            <div v-if="survey !== null" class="d-flex justify-content-center flex-column">
                <h2 class="text-center text-indigo-darkness fs-3 text-start text-title-bat" v-if="survey">{{ survey.name
                    }} </h2>
                <p class="text-center mt-2"
                    :class="{ 'text-center ': is_popup == false, 'text-start text-bat': is_popup == true }">
                    {{ survey.description }}
                </p>
            </div>
            <div class="row">
                <div class="col-12 col-md-2 avance reto-mobile pt-3"></div>
                <div class="col-12 col-md-8 avance reto-mobile pt-3">
                    <div class="d-flex justify-content-end progress-container-survey mt-2 mb-2">
                        <span><span style="color: #204F9A;">{{ this.quest  }}/{{ this.questions.length
                            }}</span></span>
                    </div>
                    <div class="progress-container-survey position-relative">
                        <el-progress :percentage="percentage" :color="progressColor" :stroke-width="16"
                                     :show-text="false"></el-progress>
                        <div class="progress-dots-survey">
                            <div v-for="(dot, index) in dotPositions" :key="index" :style="getDotStyle(dot)"></div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-2 avance reto-mobile pt-3"></div>
                <div class="col-12 col-md-2 avance reto-mobile pt-3"></div>
                <div v-if="current_question !== null" class="col-12 col-md-8">
                    <p class="title-aprendizaje fw-bold fs-6 my-3 ">
                        <strong :class="{ ' ': is_popup == false, ' text-bat': is_popup == true }">
                            {{ current_question.question }}
                        </strong>
                    </p>
                    <div v-for="option in current_question.question_option">
                        <div v-if="current_question.survey_question_type_id == 1" class="my-3 d-flex flex-column align-items-start w-100"
                            :class="{ ' ': is_popup == false, 'text-start text-bat': is_popup == true }">
                            <el-radio-group v-model="uniqAnswer" class="w-100 d-flex flex-column">
                                <el-radio :label="option.id" @change="nextQuestion(option.next_question_id)" class="d-flex align-items-center text-wrap text-break w-100"
                                style="white-space: normal; word-break: break-word; display: flex; align-items: center; line-height: 1.5;">{{
            option.answer }}</el-radio>
                            </el-radio-group>
                        </div>
                        <div v-else-if="current_question.survey_question_type_id == 2">
                            <div v-if="current_question.input_type == 'text'">
                                <div class="form-pass">
                                    <div class="d-flex flex-column">
                                        <label :class="labelClassesNumber"
                                            :style="{
                                                color: !errorText ? (focusStates.openAnswer && openAnswer !== '' ? '#83D300' : '#204F9A') : '#ff0000',
                                                background: is_popup ? '#ffffff' : '#F8F9FA'
                                            }"
                                            for="text-input">
                                            Ingresa tu respuesta
                                        </label>
                                        <div class="pass-ch mt-3 pb-0" :style="{border: errorText ? '2px solid #ff0000' : openAnswer !== '' ? '2px solid #83D300' : '2px solid #204F9A'}">
                                            <el-input v-model="openAnswer"
                                                    id="text-input"
                                                    :class="{ 'text-blue': focusStates.openAnswer && !errorText, 'text-red': errorText, 'border-red': errorText }"
                                                    @focus="handleFocus('openAnswer')"
                                                    @blur="handleBlur('openAnswer');"
                                                    @input="updateInputText">
                                            </el-input>
                                        </div>
                                        <div>
                                            <p v-if="errorText" class="text-red" :style="{ marginRight: '0%', textAlign: 'left', display: 'block', width: '100%', marginLeft: '5%', fontWeight: 'normal'  }">
                                              Este campo no puede estar vacío.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
<!--                                <p class="text-left mt-2 " :class="{'text-left': true,'mt-2': true,'text-red': errorMessage}">-->
<!--                                    La respuesta sólo pueden contener caracteres numéricos sin puntos, ni comas, ni espacios.</p>-->
<!--                                &lt;!&ndash; <el-input-number @input="updateInputNumber" placeholder="Ingresa tu respuesta" v-model="openAnswer" :controls="false" :min="0" ></el-input-number> &ndash;&gt;-->
<!--                                &lt;!&ndash; <input type="number" class="form-control" placeholder="Ingresa tu respuesta" v-model="openAnswer" @input="updateInputNumber" min="0"> &ndash;&gt;-->
<!--                                <input type="number" class="form-control" placeholder="Ingresa tu respuesta"-->
<!--                                    v-model="openAnswer" @input="updateInputNumber" min="0">-->
                                <div class="form-pass">
                                    <div class="d-flex flex-column">
                                        <label :class="labelClassesNumber"
                                               :style="{
                                               color: !errorNumber ? focusStates.openAnswer && openAnswer !== '' ? '#83D300': !focusStates.openAnswer && openAnswer !== ''? '#83D300': '#204F9A'  : errorNumber ? '#ff0000' : 'inherit',
                                               background: is_popup? '#ffffff':'#F8F9FA'   }"
                                               for="number">Ingresa el valor</label>
                                        <div class="pass-ch mt-3 pb-0"  :style="{border: errorNumber ? '2px solid #ff0000' : openAnswer !== '' ? '2px solid #83D300': '2px solid #204F9A'}">
                                            <input v-model="openAnswer" type="text" id="number"
                                                   :class="{ 'text-blue': focusStates.openAnswer && !errorNumber, 'text-red': errorNumber, 'border-red': errorNumber}"
                                                   @focus="handleFocus('openAnswer')" @blur="handleBlur('openAnswer');"
                                                   @input="updateInputNumber" autocomplete="off">
                                        </div>
                                        <p v-if="errorNumber" class="text-red" :style="{ marginRight: '0%', textAlign: 'left', display: 'block', width: '100%', marginLeft: '5%' }">{{ messageErrorNumber }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <el-checkbox-group v-model="multiAnswer" class="w-100 d-flex flex-column text-wrap text-break"
                                :class="{ ' ': is_popup == false, 'text-start text-bat': is_popup == true }">
                                <el-checkbox :label="option.id" @change="isQuestionAnswered = true" class="d-flex align-items-center text-wrap text-break w-100 mb-2"
                                style="white-space: normal; word-break: break-word; display: flex; align-items: center;">{{ option.answer
                                    }}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                    <br>
                    <div>
                        <div v-if="!is_popup" class="row">
                            <div
                                class="col-12 col-md-6 d-flex justify-content-center justify-content-md-start text-title-bat order-2 order-md-1">
                                <button v-if="step > 0" @click="previewsStep"
                                    class="button button-underline w-100 border-blue mt-3 mt-md-0 text-decoration-none">Anterior</button>
                                <button v-else class="button button-underline disabled d-none">Anterior</button>
                            </div>
                            <p v-if="!isQuestionAnswered || isErrorInput || errorQuestions" class="text-red" :style="{ marginRight: '0%', textAlign: 'left', display: 'block', width: '100%', fontWeight: 'normal !important'}">{{ messageErrorQuestions }}</p>
                            <div
                                class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end text-title-bat order-1 order-md-2">
                                <button v-if="step + 1 < questions.length" @click="nextStep"
                                    class="button button-blue px-0 px-md-4 w-100">Siguiente</button>
                                <button v-else @click="finishSurvey" :disabled="!isQuestionAnswered || isErrorInput || errorQuestions"
                                    class="button button-blue px-0 px-md-4 w-100">Enviar respuesta</button>
                            </div>
                        </div>

                        <!-- Botones encuesta popups -->
                        <div v-else class="row">
                            <div
                                class="col-12 justify-content-center justify-content-md-start text-title-bat order-3 order-md-3 mt-3">
                                <a v-if="step > 0" @click="previewsStep"
                                    class="button-underline w-100  mt-15 mt-md-5 text-decoration-none text-capitalize text-decoration-underline btn-back">Anterior</a>
                                <a v-else
                                    class=" button-underline w-100  mt-15 mt-md-5 text-decoration-none d-none">Anterior</a>
                            </div>
                            <p v-if="!isQuestionAnswered || isErrorInput || errorQuestions" class="text-red" :style="{ marginRight: '0%', textAlign: 'left', display: 'block', width: '100%', fontWeight: 'normal !important'}">{{ messageErrorQuestions }}</p>
                            <div
                                class="col-12 justify-content-center justify-content-md-end text-title-bat order-1 order-md-2">
                                <button v-if="step + 1 < questions.length" @click="nextStep" class="w-full w-100 p-3 btn-popups">Siguiente pregunta</button>
                                <div v-else>
                                    <el-button plain @click="finishSurvey" :disabled="!isQuestionAnswered || isErrorInput  || errorQuestions" class="w-full w-100 p-3 btn-popups">
                                        Enviar
                                    </el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="modal_finish" :width="$mq === 'sm' ? '90%' : '25%'" :close-on-click-modal="false"
            :close-on-press-escape="false" :show-close="false">
            <div class="align-items-center text-center flex-column justify-content-center" v-if="survey">
                <img src="/img-version2/modal/tick-circle.svg" alt="image 8">
                <h4>¡Felicitaciones!</h4>
                <div v-if="survey.points_to_win > 0 && isLinked">
                    <h5>Ganaste: {{ survey.points_to_win }} puntos.<br></h5>
                </div>
                <p>Completaste la encuesta: {{ survey.name }}<br> {{ survey.end_message }} <br></p>
                 <a href="#" @click="returnView()" class="button button-blue px-5">Aceptar</a>
<!--                <a href="#" @click="returnPageSurvey()" class="button button-blue px-5">Aceptar</a>-->
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { EventBus } from "../../app";

export default {
    props: {
        survey: {
            default: null,
        },
        is_popup: {
            default: false,
        },
        show_header: {
            default: true,
        }
    },
    data() {
        return {
            isQuestionAnswered: true,
            loading: 0,
            step: 0,
            percentage: 0,
            quest: 1,
            questions: [],
            lastQuestion: 0,
            uniqAnswer: null,
            openAnswer: '',
            multiAnswer: [],
            questionsHistory: [],
            progressHistory: [],
            current_question: null,
            modal_finish: false,
            first_time: true,
            nextQuestionId: null,
            colorBG: '#000',
            focusStates: {
                openAnswer: false,
            },
            errorNumber: false,
            messageErrorNumber: '',
            isErrorInput: false,
            dotPositions: [20, 40, 60, 80],
            errorQuestions: false,
            messageErrorQuestions: '',
            errorText: false,
            messageErrorText: false,

            isLinked: false,
        }
    },
    computed: {
        labelClassesNumber() {
            return {
                'text-green': this.focusStates.openAnswer && !this.errorNumber && this.openAnswer !== '',
                'text-blue': this.focusStates.openAnswer && !this.errorNumber && this.openAnswer === '',
                'text-red': this.errorNumber,
            };
        },
    },
    mounted() {
        this.getQuestions()
        this.validateLinkingDate();
    },
    methods: {
        getQuestions() {
            this.loading++
            axios.get(`/survey/list-questions/${this.survey.id}`)
                .then(({ data }) => {
                    this.questions = data.questions
                    this.lastQuestion = data.lastQuestion
                    this.questionsHistory.push(this.step)

                    if (this.questions.length > 0) {
                        if (this.lastQuestion) {
                            const tempQuestions = this.questions
                            tempQuestions.some((question, index) => {
                                if (index !== 0) {
                                    this.step++
                                    this.quest++
                                }
                                this.questionsHistory.push(this.step)
                                if (this.lastQuestion.id == question.id) {
                                    this.current_question = question
                                    return true
                                }
                            });
                            this.percentage = Math.trunc((this.quest * 100) / this.questions.length)
                        } else {
                            this.current_question = this.questions[0]
                            this.percentage = Math.trunc((this.quest * 100) / this.questions.length)
                            this.questionsHistory.push(this.step)
                        }
                    }
                    this.getQuestionAnswer(this.current_question.id)
                    this.loading--
                })
        },
        clearAnswers() {
            this.uniqAnswer = null
            this.openAnswer = ''
            this.multiAnswer = []
            this.isQuestionAnswered = false
        },
        saveAnswer(lastQuestion) {
            this.loading++

            let data = {
                surveyId: this.survey.id,
                questionId: this.current_question.id,
                answer: this.uniqAnswer ? this.uniqAnswer : this.openAnswer ? this.openAnswer : this.multiAnswer,
                lastQuestion: lastQuestion ? true : false,
                percentage: this.percentage,
            }

            // axios.post(`/learning/${this.learning.id}/finish-quiz`, {questions: this.questions}).then(
            axios.post(`/survey/${this.survey.id}/saveAnswer`,
                data).then(({ data }) => {
                    //
                }).finally(() => {
                    this.clearAnswers()
                    this.loading--
                })
        },
        getQuestionAnswer(questionId) {
            this.loading++
            axios.get(`/survey/${this.survey.id}/getAnswer/${this.current_question.id}`)
                .then(({ data }) => {
                    if (data.answer) {
                        this.isQuestionAnswered = false
                        if (this.current_question.survey_question_type_id == 1) {
                            this.uniqAnswer = data.answer
                            this.nextQuestionId = data.nextQuestionId
                        } else if (this.current_question.survey_question_type_id == 2) {
                            this.openAnswer = data.answer
                        } else {
                            this.multiAnswer = data.answer
                        }
                    } else {
                        this.clearAnswers()
                    }
                }).finally(() => {
                    this.loading--
                })
        },
        updateInputNumber() {
            this.errorNumber = false;
            if (!/^\d+$/.test(this.openAnswer)) {
                this.errorNumber = true;
                this.isErrorInput = true;
                this.messageErrorNumber = 'Ingresa sólo números.';
            }else if(this.openAnswer.length < 3){
                this.errorNumber = true;
                this.isErrorInput = true;
                this.messageErrorNumber = 'Mínimo permitido: 3 caracteres.';
            }else if (this.openAnswer == '') {
                this.errorNumber = true;
                this.isErrorInput = true;
                this.errorMessage = 'Este campo no puede estar vacío.';

            } else {
                this.errorNumber = false;
                this.isErrorInput = false;
                if (this.openAnswer != '' && Number(this.openAnswer) >= 0) {
                    this.isQuestionAnswered = true
                } else {
                    this.isQuestionAnswered = false
                }
            }
        },
        nextQuestion(nextQuestionId) {
            this.isQuestionAnswered = true
            this.nextQuestionId = nextQuestionId
            return this.nextQuestionId
        },
        nextStep() {
            this.loading++
            if (this.current_question.survey_question_type_id === 1 && !this.uniqAnswer) {
                this.errorQuestions = true;
                this.messageErrorQuestions  = "Debes ingresar o seleccionar una respuesta para continuar.";
                this.loading--;
                return;
            }
            if (this.current_question.survey_question_type_id === 2 && this.current_question.input_type === 'text') {
                if (!this.openAnswer || this.openAnswer.trim() === '') {
                    this.errorText = true;
                    this.loading--;
                    return;
                }
            }
            if (this.current_question.survey_question_type_id === 3 && this.multiAnswer.length === 0) {
                this.errorQuestions  = true;
                this.messageErrorQuestions = "Debes ingresar o seleccionar una respuesta para continuar.";
                this.loading--;
                return;
            }
            this.errorQuestions = false;
            this.messageErrorQuestions = "";

            this.isQuestionAnswered = true
            this.saveAnswer();

            if(this.current_question.survey_question_type_id == 2 && this.current_question.input_type != 'text'){
                this.updateInputNumber();
                if(this.errorNumber){
                    this.loading--;
                    return;
                }
            }
            this.saveAnswer()
            if (this.nextQuestionId == null) {
                this.step++
                this.current_question = this.questions[this.step]
                this.quest++
            } else {
                const tempQuestions = this.questions.slice(this.step + 1)
                for (const question of tempQuestions) {
                    this.step++;
                    this.quest++;

                    if (this.nextQuestionId == question.id) {
                        this.current_question = question;
                        break;
                    }
                }
                this.nextQuestionId = null
            }
            this.getQuestionAnswer(this.current_question.id)
            this.questionsHistory.push(this.step)
            this.percentage = Math.trunc((this.quest * 100) / this.questions.length)
            window.scrollTo({ top: 100, left: 100, behavior: 'smooth' });
            this.loading--
        },
        previewsStep() {
            this.errorQuestions = false;
            this.messageErrorQuestions = "";
            this.isQuestionAnswered = false;
            this.isErrorInput = false;

            this.questionsHistory.pop()
            this.loading++

            this.step = this.questionsHistory[this.questionsHistory.length - 1]
            this.quest = this.questionsHistory[this.questionsHistory.length - 1] + 1
            this.current_question = this.questions[this.questionsHistory[this.questionsHistory.length - 1]]
            window.scrollTo({ top: 100, left: 100, behavior: 'smooth' });

            this.getQuestionAnswer(this.current_question.id)
            this.percentage = Math.trunc((this.quest * 100) / this.questions.length)
            this.loading--
        },
        finishSurvey() {
            this.loading++
            let lastQuestion = true

            if(this.current_question.survey_question_type_id == 2 && this.current_question.input_type != 'text') {
                this.updateInputNumber();
                if (this.errorNumber) {
                    return;
                }
            }
            this.saveAnswer(lastQuestion)

            if (this.is_popup == false) {
                this.modal_finish = true
            } else {
                this.closeParentPopup()
                const h = this.$createElement;
                this.$notify({
                    title: '¡Felicitaciones!',
                    message: (this.survey && this.survey.end_message && this.survey.end_message !== null) ? this.survey.end_message : 'Completaste la encuesta. ¡Ganaste ' + this.survey.points_to_win + ' puntos!',
                    type: 'success',
                    duration: 6000
                });
                // setTimeout(function() {
                // window.location.reload();
                // }, 5000);
                // window.location.reload();
                // this.pageReload();
                // setInterval(() => {
                //     this.pageReload();
                // }, 0);

            }
            this.loading--
        },
        closeParentPopup() {
            this.$emit('close-parent-popup');
        },
        // pageReload() {
        //     window.location.reload();
        // },
        returnView() {
            EventBus.$emit('refresh-points', true);
            if (window.history.length > 3) {
                window.open(`/retos?page=1&option=survey`, "_self", "noopener,noreferrer")
            } else {
                window.open(`/retos?page=1&option=survey`, "_self", "noopener,noreferrer")
            }
        },
        progressColor() {
            if (this.progressPercentage === 0) {
                return '#dcdfe6';
            }
            return this.progressPercentage > 75 ? '#204F9A' : '#204F9A';
        },
        getDotStyle(percentage) {
            const position = Math.min(Math.max(percentage, 0), 100) + '%';
            return {
                left: position,
                top: '50%',
                transform: 'translate(-50%, -50%)'
            };
        },
        handleFocus(field) {
            this.$set(this.focusStates, field, true);
        },
        handleBlur(field) {
            this.$set(this.focusStates, field, false);
        },
        updateInputText() {
            this.errorText = false;
            this.isErrorInput = false;

            if (!this.openAnswer || this.openAnswer.trim() === '') {
                this.errorText = true;
                this.isErrorInput = true;
                this.messageErrorText = 'Este campo no puede estar vacío.';
            }
            else if (this.openAnswer.trim() === '') {
                this.errorText = true;
                this.isErrorInput = true;
                this.messageErrorText = 'La respuesta no puede contener solo espacios.';
            } else {
                this.errorText = false;
                this.isErrorInput = false;
                this.isQuestionAnswered = true;
            }
        },
        validateLinkingDate(){
            axios
                .get(`/validate-linking-date`)
                .then(({ data }) => {
                    this.isLinked = data.is_linked;
                })
                .catch(error => {
                    console.error('Error al obtener el estado de vinculación al punto de venta:', error);
                    this.isLinked = false;
                });
        },
    },
}
</script>
